export default "__VITE_ASSET__19646fd0__"